<template>
  <Minimal v-if="isMinimal" />

  <template v-else>
    <DealsCards v-if="isDealsEnabled" />
    <Desktop v-if="isDesktop" />
    <Mobile v-else>
      <template #top>
        <Skeleton v-if="isKsFlagsLoading" :height="'43px'" />
      </template>
    </Mobile>
  </template>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { ref, computed, defineAsyncComponent } from 'vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import Desktop from './header-desktop/Desktop.mcom';
import Mobile from './header-mobile/Mobile.common';
import DealsCards from './header-responsive/DealsCards.mcom';
import useKillswitches from '../composables/useKillswitches';
import { onKsFlagsReady } from '~/events';

import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import addWindowPop from '~/utils/addWindowPop';

const props = defineProps({
  isMinimal: {
    type: Boolean,
    default: false,
  },
  isPermanentSigninTooltip: {
    type: Boolean,
    default: false,
  },
  isDeals: {
    type: Boolean,
    default: false,
  },
  isProminentSearchBar: {
    type: Boolean,
    default: false,
  },
});

const Minimal = defineAsyncComponent(() => import(/* webpackChunkName: "Minimal" */ './header-responsive/MinimalHeader.common'));

const envProps = useEnvProps();
const hostlink = envProps.hostlink;
const navViewType = useNavViewType();

const killswitches = useKillswitches();
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);
const isDealsEnabled = computed(() => !!killswitches.value.vueDealsEnabled && props.isDeals);
const isKsFlagsLoading = ref(true);

addWindowPop(hostlink);

onKsFlagsReady(() => {
  isKsFlagsLoading.value = false;
});
</script>
